const Ext = require('ext')
const Matcher = require('smartrules/designer/Matcher')

const NoMatcher = Ext.define(null, {
  extend: Matcher,

  constructor(cfg = {}) {
    cfg = Ext.applyIf(cfg, {
      cls: 'no-matcher',
      items: [
        {
          xtype: 'label',
          html: '',
          height: 22
        }
      ]
    })
    this.callParent([cfg])
  },

  getValue() {
    return ''
  }
})

module.exports = NoMatcher
